export default {
    SUMMIT_ENABLE:false,
    ATC_ENABLE:true,
    EDOTCO_ENABLE:false,
    CUSTOMER_SITE:'Customer',
    APP_KEY:'base64:zFzih483S8geoMKMdndhsmjFsssJ/hoqroCNft+qc5o=',
    key: 'app-key',
    wsHost: 'atcws.iotajra.com',
    wssHost: 'atcws.iotajra.com',
    wsPort: 6001,
    wssPort: 443,
    cluster:'mt1',
};